import { COMMUNICATION_CHART_CROSS_TEAM_AGGREGATE_NODE_ID, COMMUNICATION_CHART_EXTERNAL_NODE_ID, getCommunicationChartTeamIdForCrossTeamSpaceNode, getCommunicationChartTeamIdForInternalNode } from '@web/components/CommunicationNetworkGraph/core/communicationChart/constants';
import { CommunicationChartNodeKindEnum, isCommunicationChartCrossTeamNodeKind, isCommunicationChartOrgTeamNodeKind, isCommunicationChartPersonNode } from '@web/components/CommunicationNetworkGraph/core/communicationChart/nodeKind';
import { isCommunicationChartEmployeeScope, isCommunicationChartOrgScope, isCommunicationChartTeamScope } from '@web/components/CommunicationNetworkGraph/core/communicationChart/types';
export var isCommunicationChartOrgTeamNode = function (node, scope) {
    return isCommunicationChartOrgScope(scope) &&
        isCommunicationChartOrgTeamNodeKind(node.kind);
};
export var isCommunicationChartExternalAggregateNode = function (node, scope) {
    return (isCommunicationChartOrgScope(scope) ||
        isCommunicationChartTeamScope(scope)) &&
        node.nodeId === COMMUNICATION_CHART_EXTERNAL_NODE_ID &&
        node.kind === CommunicationChartNodeKindEnum.External;
};
export var isCommunicationChartCrossTeamAggregateNode = function (node, scope) {
    return isCommunicationChartTeamScope(scope) &&
        node.nodeId === COMMUNICATION_CHART_CROSS_TEAM_AGGREGATE_NODE_ID;
};
export var isCommunicationChartTeamOnlySatelliteNode = function (node, scope) {
    return isCommunicationChartOrgScope(scope) &&
        node.kind === CommunicationChartNodeKindEnum.InternalMeet;
};
export var isCommunicationChartCrossTeamSatelliteNode = function (node, scope) {
    return isCommunicationChartOrgScope(scope) &&
        node.kind === CommunicationChartNodeKindEnum.CrossTeamSpaceChat;
};
export var isCommunicationChartHubSatelliteInspectorNode = function (node, scope) {
    return isCommunicationChartTeamOnlySatelliteNode(node, scope) ||
        isCommunicationChartCrossTeamSatelliteNode(node, scope);
};
export var resolveCommunicationChartHubSatelliteInspectorVariant = function (node, scope) {
    if (isCommunicationChartTeamOnlySatelliteNode(node, scope)) {
        return 'teamOnly';
    }
    if (isCommunicationChartCrossTeamSatelliteNode(node, scope)) {
        return 'crossTeam';
    }
    return null;
};
export var getCommunicationChartHubSatelliteTeamId = function (node) {
    var _a;
    return (_a = getCommunicationChartTeamIdForInternalNode(node.nodeId)) !== null && _a !== void 0 ? _a : getCommunicationChartTeamIdForCrossTeamSpaceNode(node.nodeId);
};
/** @deprecated Use getCommunicationChartHubSatelliteTeamId */
export var getCommunicationChartTeamOnlySatelliteTeamId = function (node) { return getCommunicationChartTeamIdForInternalNode(node.nodeId); };
export var isCommunicationChartTeamScopeDashboardUserNode = function (node, scope) {
    return (isCommunicationChartTeamScope(scope) ||
        isCommunicationChartEmployeeScope(scope)) &&
        isCommunicationChartPersonNode(node) &&
        !isCommunicationChartCrossTeamNodeKind(node.kind);
};
/** Strip leading numeric list prefixes from chart labels (e.g. `03. Ava`). */
export var formatCommunicationChartPersonDisplayName = function (name) { return name.replace(/^\d+\.\s*/, '').trim(); };
export var getCommunicationChartPersonInitials = function (name) {
    var _a, _b;
    var parts = formatCommunicationChartPersonDisplayName(name)
        .split(/\s+/)
        .filter(Boolean);
    if (parts.length === 0) {
        return '?';
    }
    if (parts.length === 1) {
        return parts[0].slice(0, 2).toUpperCase();
    }
    return "".concat((_a = parts[0][0]) !== null && _a !== void 0 ? _a : '').concat((_b = parts[parts.length - 1][0]) !== null && _b !== void 0 ? _b : '').toUpperCase();
};
export var joinCommunicationChartElementClasses = function () {
    var classes = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        classes[_i] = arguments[_i];
    }
    return classes.filter(Boolean).join(' ') || undefined;
};
